module.exports = __webpack_public_path__ + "static/media/newsletter.2456eab7.png";